import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import images from '../../helpers/images';
import Header from '../parts/Header';

import {BiError}  from "react-icons/bi";
import helpers from '../../helpers/helpers';
 
function PaymentFailedPage (){
    const home_url = helpers.getHomeURL();

    return (
        <>
            <Header />
            <section className="cf-thank-you">
                <div className="container text-center p-3">
                    {/* <img src={images.successIcon} /> */}
                    <BiError className='text-danger' style={{fontSize: '10rem'}} />
                    <h1 className='fw-bold mb-5 fs-1'>Oh no! Something went wrong.</h1>
                    <h3 className="text-larged mb-5">Please try again. We were unable to process your payment.<br/>If you still encounter same error, try another giving method.</h3>
                    <Link className="btn btn-lg btn-primary btn-orange" to={home_url}>Go to Form Page</Link>
                </div>
            </section>
        </>
    )
}
 
export default PaymentFailedPage;